import { render, staticRenderFns } from "./NinePointNine.vue?vue&type=template&id=55e72864"
import script from "./NinePointNine.vue?vue&type=script&lang=js"
export * from "./NinePointNine.vue?vue&type=script&lang=js"
import style0 from "./NinePointNine.vue?vue&type=style&index=0&id=55e72864&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports